import { Search } from 'components/Search';
import {
  TreeMenu,
  TreeMenuItem,
  useTreeMenuRouteSelection,
  useTreeMenuSearch,
} from 'components/TreeMenu';
import React, { useMemo } from 'react';

import usePageSidebarStyles from './styles';
import { PageSidebarProps } from './types';

const emptyMenu: TreeMenuItem[] = [];

const PageSidebar: React.FunctionComponent<PageSidebarProps> = (props) => {
  const { search = true, menu = emptyMenu, content = null, treeMenuOptions } = props;
  const classes = usePageSidebarStyles(props);

  const { searchProps, treeMenuProps: searchMenuProps } = useTreeMenuSearch(menu);
  const routeSelectionProps = useTreeMenuRouteSelection(menu, treeMenuOptions);

  const expanded = useMemo(() => {
    if (searchMenuProps.expanded.length) {
      return searchMenuProps.expanded;
    }
    return routeSelectionProps.expanded;
  }, [routeSelectionProps.expanded, searchMenuProps.expanded]);

  return (
    <div className={classes.sidebarWrapper}>
      <>
        {content ? (
          content
        ) : (
          <>
            {search ? <Search {...searchProps} fullWidth className={classes.search} /> : null}
            {menu ? (
              <nav style={{ flex: 1 }}>
                <TreeMenu {...searchMenuProps} {...routeSelectionProps} expandedItems={expanded} />
              </nav>
            ) : null}
          </>
        )}
      </>
    </div>
  );
};

export default PageSidebar;
